import React from "react";
import {NavLink} from "react-router-dom";
import {translate} from "./Language/Translate";
import {useSelector} from "react-redux";
import {Nav, NavDropdown} from "react-bootstrap";
import Auth from "../helpers/auth";

const HeaderNavLinks = () => {
  const currentUser = useSelector(st => st.currentUser);

  const isMainAdmin = Auth.isMainAdmin(currentUser.userStatus);
  // console.log({currentUser, isAdmin});

  const schulenAdmin = (
    <NavDropdown title="Schulen" id="collasible-nav-dropdown">
      <NavDropdown.Item as={NavLink} exact to="/companies">
        Schulen
      </NavDropdown.Item>
      <NavDropdown.Item as={NavLink} exact to={`/users`}>
        Benutzer
      </NavDropdown.Item>
    </NavDropdown>
  );
  const schulenNotAdmin = (
    <Nav.Link as={NavLink} exact to={`/companies`}>
      Schulen
    </Nav.Link>
  );
  return (
    <div className="container">
      <Nav.Link as={NavLink} exact to={`/home`}>
        {translate("Home")}
      </Nav.Link>
      {isMainAdmin ? schulenAdmin : schulenNotAdmin}
      <Nav.Link as={NavLink} exact to={`/klausuren`}>
        Gutachten
      </Nav.Link>
      {currentUser.username ? (
        <Nav.Link as={NavLink} exact to={`/logout`}>
          Logout
        </Nav.Link>
      ) : null}
    </div>
  );
};

export default HeaderNavLinks;
